var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',[_c('Row',{staticClass:"header mb-3"}),_c('Row'),_c('Row'),_c('Row',{staticClass:"w-75"}),_c('Row',{staticClass:"header mt-5 mb-3"}),_c('Row'),_c('Row'),_c('Row',{staticClass:"w-75"}),_c('Row',{staticClass:"w-75"}),_c('Row',{staticClass:"w-75"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }